// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/** @hidden */
var TimelineViewRowContentVue2 = {
  name: 'KendoTimelineViewRowContent',
  props: {},
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("div", {
      "class": "k-sticky-cell"
    }, [h("div", {
      "class": "k-scheduler-cell k-side-cell"
    })]);
  }
};
/** @hidden */
var TimelineViewRowContent = TimelineViewRowContentVue2;
export { TimelineViewRowContent, TimelineViewRowContentVue2 };